import { KeyValue } from "@/main/models/common";
import { DeliveryTypeActionTypes, DeliveryTypeTypes } from "./deliveryTypeTypes";

export function getDeliveryTypes(): DeliveryTypeActionTypes {
	return {
		type: DeliveryTypeTypes.GET_DELIVERYTYPES,
	};
}

export function saveDeliveryTypes(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): DeliveryTypeActionTypes {
	return {
		type: DeliveryTypeTypes.SAVE_DELIVERYTYPES,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerDeliveryTypes(): DeliveryTypeActionTypes {
	return {
		type: DeliveryTypeTypes.RESET_REDUCER_DELIVERYTYPES,
	};
}
